<template>
  <div class="ProductCard__Badges" v-if="badgeText || imageBadge">
    <div class="ProductCard__TextBadgeWrapper" v-if="badgeText">
      <span data-ht-element="text-badge" class="ProductCard__TextBadge t5" v-html="badgeText"></span>
    </div>
    <div class="ProductCard__ImgBadgeWrapper" v-if="imageBadge">
      <img data-ht-element="image-badge" class="ProductCard__ImgBadge" :class="loadedClass" :src="imageBadge.src" alt="Award" @load="transitionMedia" />
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';

const mediaLoaded = ref(false);
const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
});

const transitionMedia = () => (mediaLoaded.value = true);
const loadedClass = computed(() => {
  return mediaLoaded.value ? 'ProductCard__ImgBadge--Loaded' : '';
});

const badgeText = computed(() => {
  const text = props.item?.textBadge?.value ?? false;
  const hasTextBadge = text && JSON.parse(text)[0] !== 'false' && JSON.parse(text)[0] !== '';

  return hasTextBadge ? JSON.parse(text)[0] : false;
});

const imageBadge = computed(() => {
  const image = props.item?.imageBadge?.value ?? false;
  const hasImageBadge = image && image !== 'false' && image !== '';

  return hasImageBadge ? JSON.parse(image)[0] : false;
});
</script>

<style lang="css" scoped>
.ProductCard__ImgBadge,
.ProductCard-ImageWrapper--Loaded .ProductCard__ImgBadge {
  opacity: 0;
  transition: opacity 200ms cubic-bezier(0, 0.55, 0.45, 1);
}

.ProductCard-ImageWrapper--Loaded .ProductCard__ImgBadge--Loaded {
  opacity: 1;
}
</style>
